import React, { useCallback, useState, useEffect } from 'react';
import { DataGrid, Column, FilterRow, Scrolling, SearchPanel, Editing } from 'devextreme-react/data-grid';
import { RowInsertingEvent, RowUpdatingEvent, RowRemovingEvent } from 'devextreme/ui/data_grid';

import { formatMessage } from 'devextreme/localization';

import GlobalLoader from '../loader/GlobalLoader';

import WorkspaceApi from '../../api/WorkspaceApi';
import WorkspaceDto from '../../classes/dtos/workspacemodule/WorkspaceDto';


interface WorkspaceGridProps {
}

const WorkspaceGrid: React.FC<WorkspaceGridProps> = () => {

    const [workspaces, setWorkspaces] = useState<Array<WorkspaceDto> | null>(null);

    const refresh = useCallback(() => {
        if (!workspaces) {
            WorkspaceApi.GetWorkspacesAsync().then(result => {
                if (result.IsFailed()) {
                    alert("ERROR");
                } else {
                    setWorkspaces(result.Result);
                }
            });
        }
    }, [workspaces]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    function insertRow(e: RowInsertingEvent<WorkspaceDto, any>) {
        e.cancel = WorkspaceApi.CreateWorkspaceAsync(e.data.Name)
            .then(result => {
                if (result.IsFailed()) {
                    alert("ERROR");
                }
                setWorkspaces(null);
            });
    }

    function updateRow(e: RowUpdatingEvent<WorkspaceDto, any>) {
        const id = e.newData.Id ?? e.oldData.Id;
        const name = e.newData.Name ?? e.oldData.Name;

        e.cancel = WorkspaceApi.UpdateWorkspaceAsync(id, name)
            .then(result => {
                if (result.IsFailed()) {
                    alert("ERROR");
                }
                setWorkspaces(null);
            });
    }

    function removeRow(e: RowRemovingEvent<WorkspaceDto, any>) {
        e.cancel = WorkspaceApi.DeleteWorkspaceAsync(e.data.Id)
            .then(result => {
                if (result.IsFailed()) {
                    alert("ERROR");
                }
                setWorkspaces(null);
            });
    }

    if (!workspaces) {
        return <GlobalLoader />
    }

    return (
        <div className="block-card">
            <div className="block-card__header">
                <h2>{formatMessage("SettingsWorkspaceGrid_Title")}</h2>
            </div>
            <DataGrid
                dataSource={workspaces}
                keyExpr="Id"
                showBorders={false}
                width="100%"
                onRowInserting={insertRow}
                onRowUpdating={updateRow}
                onRowRemoving={removeRow}
            >
                <FilterRow visible={true} />
                <SearchPanel visible={true} />
                <Scrolling mode="virtual" />
                <Editing
                    mode="row"
                    allowAdding={true}
                    allowUpdating={true}
                    allowDeleting={true}
                />
                <Column dataField="Name" caption={formatMessage("SettingsWorkspaceGrid_Name")} minWidth={200} />
            </DataGrid>
        </div>
    );
};

export default WorkspaceGrid;
